import { TeaBlocksError } from './../../TeaBlocksError';
import { ReturnBlock } from "../ReturnBlock";
import { VoidBlock } from "../VoidBlock";

export class ArraySetIndex extends VoidBlock {
    arrName: string;
    index: ReturnBlock;
    value: ReturnBlock;

    /**
     * Constructor
     * @param id the id of state node
     * @param arrName name of array
     * @param inputs inputs[0] is the index; inputs[1] is the value
     */
    constructor(id: string, arrName: string, inputs: ReturnBlock[]) {
        super(id);
        this.arrName = arrName;
        this.index = inputs[0];
        this.value = inputs[1];
    }


    /**
     * Assigns the value to the index of this array. Computes the value being assigned
     * before the index.
     * 
     * @param varEnv variable environment
     */
    *evalBlock(varEnv: Map<string, any>) {
        let value = this.value.evalBlock(this.value.evalBlock(varEnv));

        let arr = varEnv.get(this.arrName);
        if (arr == null) throw new TeaBlocksError('Array does not exist', this.id);

        let index = Number(this.index.evalBlock(varEnv));
        if (isNaN(index)) throw new TeaBlocksError('Index is not a number', this.id);

        arr[index] = value;

        varEnv.set(this.arrName, arr);

        yield;
    }

}